import React from "react"
import red from "@material-ui/core/colors/red"
import Checkbox from "@material-ui/core/Checkbox"
import { ValidatorComponent } from "react-material-ui-form-validator"

const red300 = red["500"]
const style = {
  right: 0,
  fontSize: "12px",
  color: red300,
  position: "absolute",
  marginTop: "-25px",
}

class CheckboxValidator extends ValidatorComponent {
  render() {
    const {
      errorMessages,
      validators,
      requiredError,
      value,
      validatorListener,
      ...rest
    } = this.props

    const { isValid } = this.state
    return (
      <>
        <Checkbox
          className={!isValid ? "checkbox-error" : ""}
          {...rest}
          ref={r => {
            this.input = r
          }}
        />
        {this.errorText()}
      </>
    )
  }

  errorText() {
    const { isValid, errorMessages } = this.state
    if (!errorMessages || errorMessages == "error") {
      return null
    }
    if (isValid) {
      return null
    }
    return <p style={style}>{this.getErrorMessage()}</p>
  }
}
export default CheckboxValidator
